import { toast } from '@kalos/ui';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { type SelectChangeEvent } from '@mui/material/Select';
import { useState } from 'react';

import { PoolHeaterSellSheet } from './PoolHeaterSellSheet';
import { SellSheetCommercial } from './SellSheetCommercial';
import { SellSheetResidential } from './SellSheetResidential';
import { WaterHeaterSellSheet } from './WaterHeaterSellSheet';

export interface Props {
  propertyId: number;
  jobNumber: number;
  ownerId: number;
  onCreateDoc?: () => void;
  onClose?: () => void;
}
type SellSheetType = {
  type: string;
};

export const SellSheet: React.FC<Props> = ({
  propertyId,
  jobNumber,
  ownerId,
  onCreateDoc,
  onClose,
}) => {
  const [form, setForm] = useState<SellSheetType>({
    type: 'Choose One',
  });
  const handleChange = (event: SelectChangeEvent<string>) => {
    setForm({ type: event.target.value });
  };

  const handleCreateDoc = () => {
    toast({
      title: 'Sell Sheet Created',
      description: 'The sell sheet has been successfully created',
      variant: 'success',
    });
    onCreateDoc?.();
    onClose?.();
  };

  return (
    <div style={{ padding: '20px' }} className="relative">
      <FormControl className="properties-select">
        <InputLabel id="select-type-label" sx={{ p: 2 }}>
          Type
        </InputLabel>
        <Select
          className="min-w-[126px]"
          labelId="select-type-label"
          id="select-type"
          value={form.type}
          onChange={handleChange}
        >
          <MenuItem value="Choose One">Choose One</MenuItem>
          <MenuItem value="Residential">Residential</MenuItem>
          <MenuItem value="Commercial">Commercial</MenuItem>
          <MenuItem value="Water">Water Heater</MenuItem>
          <MenuItem value="Pool">Pool Heater</MenuItem>
        </Select>
      </FormControl>
      {form.type === 'Residential' && (
        <SellSheetResidential
          propertyId={propertyId}
          jobNumber={jobNumber}
          ownerId={ownerId}
          onCreateDoc={handleCreateDoc}
          onClose={onClose}
        />
      )}
      {form.type === 'Commercial' && (
        <SellSheetCommercial
          propertyId={propertyId}
          jobNumber={jobNumber}
          ownerId={ownerId}
          onCreateDoc={handleCreateDoc}
          onClose={onClose}
        />
      )}
      {form.type === 'Water' && (
        <WaterHeaterSellSheet
          propertyId={propertyId}
          jobNumber={jobNumber}
          ownerId={ownerId}
          onCreateDoc={handleCreateDoc}
          onClose={onClose}
        />
      )}
      {form.type === 'Pool' && (
        <PoolHeaterSellSheet
          propertyId={propertyId}
          jobNumber={jobNumber}
          ownerId={ownerId}
          onCreateDoc={handleCreateDoc}
          onClose={onClose}
        />
      )}
    </div>
  );
};
